// Entry da listagem do redesign, usada por tag.liquid e search.liquid.
// ProductBlockMobile fica de fora: ele existia para o efeito de virar o card
// legacy no mobile, e o card do redesign já mostra tudo de uma vez.
// Filtros e infinity scroll saíram com o redesign de /produtos.

import { updatePriceBlock } from '../components/utilities.js';

window.addEventListener('DOMContentLoaded', () => {
  updatePriceBlock();
});
